@if (order$ | async; as order) {
  <div class="cx-page-header">
    <span class="cx-page-title">
      {{ 'checkoutOrderConfirmation.confirmationOfOrder' | cxTranslate }}
      {{ order.replenishmentOrderCode ?? order.code }}
    </span>
  </div>
  <div class="cx-order-confirmation-message">
    <h2>{{ 'checkoutOrderConfirmation.thankYou' | cxTranslate }}</h2>
    <!-- <p>
    {{ 'checkoutOrderConfirmation.invoiceHasBeenSentByEmail' | cxTranslate }}
  </p> -->
</div>
@if (
  isGuestCustomer && orderGuid && order?.paymentInfo?.billingAddress?.email
  ) {
  <div
    >
    <cx-guest-register-form
      [guid]="orderGuid"
      [email]="order?.paymentInfo?.billingAddress?.email || ''"
    ></cx-guest-register-form>
  </div>
}
<cx-add-to-home-screen-banner></cx-add-to-home-screen-banner>
}
